import { Subject } from "rxjs";
import { Store } from "@ngrx/store";
import { Router } from "@angular/router";
import { takeUntil } from "rxjs/operators";
import { AuthService } from "./service/auth.service";
import { resetUser } from "../store/auth/auth.actions";
import { toggleAnimation } from "../shared/animations";
import { TranslateService } from "@ngx-translate/core";
import { PopupType } from "../shared/enums/popup-types";
import { showMessage } from "../shared/utils/toast.popup";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { AppService } from "../shared/services/app.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  templateUrl: "./login.html",
  animations: [toggleAnimation],
  providers: [AuthService],
  standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  private destroy$ = new Subject<void>();
  store: any;
  isLoading = false;
  passwordVisible = false;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private storeData: Store<any>,
    private appSetting: AppService,
    private authService: AuthService,
    public translate: TranslateService,
  ) {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    this.initStore();
  }

  initStore(): void {
    this.storeData.dispatch(resetUser());
    this.storeData
      .select(state => state.index)
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.store = state;
      });
  }

  login(): void {
    if (this.loginForm.valid) {
      this.isLoading = true;
      const authSubscription = this.authService
        .authenticate(this.loginForm.value)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            authSubscription.unsubscribe();
            this.isLoading = false;
            this.authService.handleAuthentication(response);
            this.router.navigate(["/"]);
          },
          error: (error) => {
            authSubscription.unsubscribe();
            this.isLoading = false;
            showMessage(PopupType.Danger, error.message);
          },
        });
    }
  }

  changeLanguage(item: any): void {
    this.translate.use(item.code);
    this.appSetting.toggleLanguage(item);
    if (this.store.locale?.toLowerCase() === "ae") {
      this.storeData.dispatch({ type: "toggleRTL", payload: "rtl" });
    }
    else {
      this.storeData.dispatch({ type: "toggleRTL", payload: "ltr" });
    }
    window.location.reload();
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
